import {
    Flex,
    Box,
    Button,
    Grid,
    Input,
    Select,
    createListCollection,
    Text,
    VStack,
    HStack,
} from "@chakra-ui/react";

import {
    Edit,
    Save,
    X,
    Eye,
    Info,
    UserCircle2,
    IdCard
} from "lucide-react";

import {
    useEffect,
    useState,
} from "react";
import {
    useDispatch,
    useSelector,
} from "react-redux";
import {
    updateProfileAction,
} from "../../../state/actions/authActions";
import { updateDriverPartnerAction,fetchMyDriverPartnerAction } from "../../../state/actions/driverPartnerActions";
import {
    toaster,
} from "../../../components/toaster";
import ActivityToast from "../../../components/ActivityToast";
import Card from "../../Dashboard/components/Card";

  const paymentMethods =
    createListCollection(
        {
            items: [
                {
                    label:
                        "Bank Transfer",
                    value:
                        "Bank",
                },
                {
                    label:
                        "Orange Money",
                    value:
                        "OrangeMoney",
                },
                {
                    label:
                        "MyZaka",
                    value:
                        "MyZaka",
                },
                {
                    label:
                        "Smega",
                    value:
                        "Smega",
                },
                {
                    label:
                        "Other",
                    value:
                        "Other",
                },
            ],
        }
    );

const PersonalInformation = ({
    driverPartner,
}) => {
    const dispatch =
    useDispatch();
    useEffect(() => {
    dispatch(
        fetchMyDriverPartnerAction()
    );
}, [dispatch]);
    const {
        updatingProfile,
    } = useSelector(
        (state) =>
            state.auth
    );
    const {
        updating,
    } = useSelector(
        (state) =>
            state.driverPartner
    );
    const user =
        driverPartner?.user;
  
    const [
        editingPersonal,
        setEditingPersonal,
    ] = useState(false);

    const [
        editingPartner,
        setEditingPartner,
    ] = useState(false);

    const [
        personalForm,
        setPersonalForm,
    ] = useState({});

    const [
        partnerForm,
        setPartnerForm,
    ] = useState({});

    useEffect(() => {
        if (!user) return;

        setPersonalForm({
            first_name:
                user.first_name || "",
            middle_name:
                user.middle_name || "",
            last_name:
                user.last_name || "",
            phone_number:
                user.phone_number || "",
            district:
                user.district || "",
            village:
                user.village || "",
            physical_address:
                user.physical_address || "",
            postal_address:
                user.postal_address || "",
            id_or_passport_number:
                user.id_or_passport_number ||
                "",
        });

        setPartnerForm({
            payment_method:
                driverPartner?.payment_method || "",
            payment_account:
                driverPartner?.payment_account || "",
            account_name:
                driverPartner?.account_name || "",
            account_number:
                driverPartner?.account_number || "",
            branch:
                driverPartner?.branch || "",
            branch_code:
                driverPartner?.branch_code || "",
        });
    }, [
        user,
        driverPartner,
    ]);

    // const fullName =
    //     [
    //         personalForm.first_name,
    //         personalForm.middle_name,
    //         personalForm.last_name,
    //     ]
    //         .filter(
    //             Boolean
    //         )
    //         .join(" ")
    //         .trim() ||
    //     user?.username ||
    //     "-";

    const API_URL =
        process.env.REACT_APP_API_BASE_URL?.replace(
            /\/$/,
            ""
        );

    const getDocumentUrl =
        (
            filePath
        ) =>
            filePath
                ? `${API_URL}/${filePath.replace(
                      /^\//,
                      ""
                  )}`
                : null;

   const handleSavePersonal =
    async () => {
        const result =
            await dispatch(
                updateProfileAction(
                    personalForm
                )
            );

        if (
            result?.success
        ) {
            toaster.create({
                render: () => (
                    <ActivityToast
                        type="success"
                        title="Profile Updated"
                        description="Your personal details were updated successfully."
                        timestamp="Just now"
                    />
                ),
            });

            setEditingPersonal(
                false
            );
        } else {
            toaster.create({
                render: () => (
                    <ActivityToast
                        type="error"
                        title="Update Failed"
                        description={
                            result?.error ||
                            "Unable to update profile."
                        }
                        timestamp="Just now"
                    />
                ),
            });
        }
    };

const handleSavePartner =
     async () => {
  const payload = {
    payment_method:
        partnerForm.payment_method,

    payment_account:
        partnerForm.payment_account,

    account_name:
        partnerForm.account_name,

    account_number:
        partnerForm.account_number,

    branch:
        partnerForm.branch,

    branch_code:
        partnerForm.branch_code,
};

console.log(
    "UPDATE PAYLOAD",
    payload
);

const result =
    await dispatch(
        updateDriverPartnerAction(
            driverPartner.driver_partner_id,
            payload
        )
    );

        if (
            result?.success
        ) {
            toaster.create({
                render: () => (
                    <ActivityToast
                        type="success"
                        title="Profile Updated"
                        description="Your personal details were updated successfully."
                        timestamp="Just now"
                    />
                ),
            });
            await dispatch(
                fetchMyDriverPartnerAction()
            );
            setEditingPersonal(
                false
            );
        } else {
            toaster.create({
                render: () => (
                    <ActivityToast
                        type="error"
                        title="Update Failed"
                        description={
                            result?.error ||
                            "Unable to update profile."
                        }
                        timestamp="Just now"
                    />
                ),
            });
        }
    };

    return (
        <Card>

            {/* PERSONAL DETAILS */}


            <HStack
                justify="space-between"
                mb={5}
            >
                <Text
                    fontSize="lg"
                    fontWeight="700"
                    color="#071D54"
                >
                    Personal Details
                </Text>

                <HStack>
                  {editingPersonal && (
                    <Button
                        size="sm"
                        colorPalette="blue"
                        loading={
                            updatingProfile
                        }
                        loadingText="Saving..."
                        onClick={
                            handleSavePersonal
                        }
                    >
                        <Save size={16} />
                        Save
                    </Button>
                )}

                    <Button
                        size="sm"
                        variant="outline"
                        onClick={() =>
                            setEditingPersonal(
                                !editingPersonal
                            )
                        }
                    >
                        {editingPersonal ? (
                            <>
                                <X size={16} />
                                Cancel
                            </>
                        ) : (
                            <>
                                <Edit size={16} />
                                Edit Personal Details
                            </>
                        )}
                    </Button>
                </HStack>
            </HStack>

            <Grid
                templateColumns={{
                    base: "1fr",
                    md: "1fr 1fr",
                }}
                gap={5}
                mb={10}
            >
                <InputField
                    label="First Name"
                    value={
                        personalForm.first_name
                    }
                    editable={
                        editingPersonal
                    }
                    onChange={(
                        value
                    ) =>
                        setPersonalForm(
                            (
                                prev
                            ) => ({
                                ...prev,
                                first_name:
                                    value,
                            })
                        )
                    }
                />

                <InputField
                    label="Middle Name"
                    value={
                        personalForm.middle_name
                    }
                    editable={
                        editingPersonal
                    }
                    onChange={(
                        value
                    ) =>
                        setPersonalForm(
                            (
                                prev
                            ) => ({
                                ...prev,
                                middle_name:
                                    value,
                            })
                        )
                    }
                />

                <InputField
                    label="Last Name"
                    value={
                        personalForm.last_name
                    }
                    editable={
                        editingPersonal
                    }
                    onChange={(
                        value
                    ) =>
                        setPersonalForm(
                            (
                                prev
                            ) => ({
                                ...prev,
                                last_name:
                                    value,
                            })
                        )
                    }
                />

                <InputField
                    label="Username"
                    value={
                        user?.username
                    }
                />

                <InputField
                    label="Email Address"
                    value={
                        user?.email
                    }
                />

                <InputField
                    label="Phone Number"
                    value={
                        personalForm.phone_number
                    }
                    editable={
                        editingPersonal
                    }
                    onChange={(
                        value
                    ) =>
                        setPersonalForm(
                            (
                                prev
                            ) => ({
                                ...prev,
                                phone_number:
                                    value,
                            })
                        )
                    }
                />

                <InputField
                    label="District"
                    value={
                        personalForm.district
                    }
                    editable={
                        editingPersonal
                    }
                    onChange={(
                        value
                    ) =>
                        setPersonalForm(
                            (
                                prev
                            ) => ({
                                ...prev,
                                district:
                                    value,
                            })
                        )
                    }
                />

                <InputField
                    label="Village"
                    value={
                        personalForm.village
                    }
                    editable={
                        editingPersonal
                    }
                    onChange={(
                        value
                    ) =>
                        setPersonalForm(
                            (
                                prev
                            ) => ({
                                ...prev,
                                village:
                                    value,
                            })
                        )
                    }
                />

                <InputField
                    label="Physical Address"
                    value={
                        personalForm.physical_address
                    }
                    editable={
                        editingPersonal
                    }
                    onChange={(
                        value
                    ) =>
                        setPersonalForm(
                            (
                                prev
                            ) => ({
                                ...prev,
                                physical_address:
                                    value,
                            })
                        )
                    }
                />

                <InputField
                    label="Postal Address"
                    value={
                        personalForm.postal_address
                    }
                    editable={
                        editingPersonal
                    }
                    onChange={(
                        value
                    ) =>
                        setPersonalForm(
                            (
                                prev
                            ) => ({
                                ...prev,
                                postal_address:
                                    value,
                            })
                        )
                    }
                />

                <InputField
                    label="ID / Passport Number"
                    value={
                        personalForm.id_or_passport_number
                    }
                    editable={
                        editingPersonal
                    }
                    onChange={(
                        value
                    ) =>
                        setPersonalForm(
                            (
                                prev
                            ) => ({
                                ...prev,
                                id_or_passport_number:
                                    value,
                            })
                        )
                    }
                />
            </Grid>


            {/* DRIVER PARTNER DETAILS */}


            <HStack
                justify="space-between"
                mb={5}
            >
                <Text
                    fontSize="lg"
                    fontWeight="700"
                    color="#071D54"
                >
                    Payment Details
                </Text>

                <HStack>
                    {editingPartner && (
                    <Button
                        size="sm"
                        colorPalette="blue"
                        loading={
                            updating
                        }
                        loadingText="Saving..."
                        onClick={
                            handleSavePartner
                        }
                    >
                        <Save size={16} />
                        Save
                    </Button>
                )}

                    <Button
                        size="sm"
                        variant="outline"
                        onClick={() =>
                            setEditingPartner(
                                !editingPartner
                            )
                        }
                    >
                        {editingPartner ? (
                            <>
                                <X size={16} />
                                Cancel
                            </>
                        ) : (
                            <>
                                <Edit size={16} />
                                Edit Payment Details
                            </>
                        )}
                    </Button>
                </HStack>
            </HStack>

            <Grid
                templateColumns={{
                    base: "1fr",
                    md: "1fr 1fr",
                }}
                gap={5}
                mb={10}
            >
           

                  <Box>
                    <Text
                        mb={2}
                        color="gray.500"
                        fontWeight="600"
                        fontSize="sm"
                    >
                        Payment Method
                    </Text>

                    {editingPartner ? (
                        <Select.Root
                            collection={
                                paymentMethods
                            }
                            value={[
                                partnerForm.payment_method,
                            ]}
                            onValueChange={(
                                e
                            ) =>
                                setPartnerForm(
                                    (
                                        prev
                                    ) => ({
                                        ...prev,
                                        payment_method:
                                            e.value[0],
                                    })
                                )
                            }
                        >
                            <Select.Trigger>
                                <Select.ValueText placeholder="Select payment method" />
                                <Select.Indicator />
                            </Select.Trigger>

                            <Select.Content>
                                {paymentMethods.items.map(
                                    (
                                        item
                                    ) => (
                                        <Select.Item
                                            key={
                                                item.value
                                            }
                                            item={
                                                item
                                            }
                                        >
                                            {
                                                item.label
                                            }
                                        </Select.Item>
                                    )
                                )}
                            </Select.Content>
                        </Select.Root>
                    ) : (
                        <Input
                            value={
                                partnerForm.payment_method
                            }
                            readOnly
                            bg="gray.50"
                        />
                    )}
                </Box>

                <InputField
                    label={
        partnerForm.payment_method === "Bank"
            ? "Bank Name"
            : "Payment Number"
    }
                    value={
                        partnerForm.payment_account
                    }
                    editable={
                        editingPartner
                    }
                    onChange={(
                        value
                    ) =>
                        setPartnerForm(
                            (
                                prev
                            ) => ({
                                ...prev,
                                payment_account:
                                    value,
                            })
                        )
                    }
                />
                {partnerForm.payment_method === "Bank" && (
                <>
                    <InputField
                label="Account Name"
                value={
                    partnerForm.account_name
                }
                editable={
                    editingPartner
                }
                onChange={(value) =>
                    setPartnerForm(
                        (prev) => ({
                            ...prev,
                            account_name: value,
                        })
                    )
                }
            />
            <InputField
                label="Account Number"
                value={
                    partnerForm.account_number
                }
                editable={
                    editingPartner
                }
                onChange={(value) =>
                    setPartnerForm(
                        (prev) => ({
                            ...prev,
                            account_number: value,
                        })
                    )
                }
            />

                            <InputField
                                label="Branch"
                                value={
                                    partnerForm.branch
                                }
                                editable={
                                    editingPartner
                                }
                                onChange={(
                                    value
                                ) =>
                                    setPartnerForm(
                                        (
                                            prev
                                        ) => ({
                                            ...prev,
                                            branch:
                                                value,
                                        })
                                    )
                                }
                            />

                            <InputField
                                label="Branch Code"
                                value={
                                    partnerForm.branch_code
                                }
                                editable={
                                    editingPartner
                                }
                                onChange={(
                                    value
                                ) =>
                                    setPartnerForm(
                                        (
                                            prev
                                        ) => ({
                                            ...prev,
                                            branch_code:
                                                value,
                                        })
                                    )
                                }
                            />

                </>
            )}
                        
                    

               
            </Grid>
            {/* DOCUMENTS */}
            <Box mt={10}>
                <HStack
                    justify="space-between"
                    mb={6}
                >
                    <Text
                        fontSize="lg"
                        fontWeight="700"
                        color="#071D54"
                    >
                        Uploaded Documents
                    </Text>

                    <HStack
                        color="gray.500"
                        fontSize="sm"
                        fontWeight="600"
                    >
                        <Info
                            size={16}
                        />

                        <Text>
                        {
                            driverPartner?.documents?.filter(
                                doc =>
                                    [
                                        "Identity Proof",
                                        "Profile Image",
                                    ].includes(
                                        doc.document_type
                                    )
                            ).length || 0
                        } Documents Total
                    </Text>
                    </HStack>
                </HStack>

                <VStack
                    gap={5}
                    align="stretch"
                >
                    {driverPartner?.documents
                        ?.filter(
                            (
                                document
                            ) =>
                                [
                                    "Identity Proof",
                                    "Profile Image",
                                ].includes(
                                    document.document_type
                                )
                        )
                        .map(
                            (
                                document
                            ) => (
                            <HStack
                                key={
                                    document.document_id
                                }
                                justify="space-between"
                                p={5}
                                border="1px solid"
                                borderColor="#E7EAF3"
                                borderRadius="20px"
                                bg="white"
                            >
                                <HStack
                                    gap={4}
                                >
                                    <Flex
                                        w="36px"
                                        h="36px"
                                        bg="#F4F7FF"
                                        borderRadius="16px"
                                        align="center"
                                        justify="center"
                                        color="#2453FF"
                                    >
                                        {document.document_type ===
                                        "Profile Image" ? (
                                            <UserCircle2
                                                size={
                                                    20
                                                }
                                            />
                                        ) : (
                                            <IdCard
                                                size={
                                                    20
                                                }
                                            />
                                        )}
                                    </Flex>

                                    <Box>
                                        <HStack
                                            mb={1}
                                        >
                                            <Text
                                                fontWeight="700"
                                                fontSize="17px"
                                                color="#071D54"
                                            >
                                                {
                                                    document.document_type
                                                }
                                            </Text>

                                           
                                        </HStack>

                                        <Text
                                            color="gray.500"
                                            fontSize="15px"
                                        >
                                            {document.document_type ===
                                            "Identity Proof"
                                                ? "National ID Card"
                                                : "Headshot"}{" "}
                                            • .
                                            {
                                                document.file_extension
                                            }
                                        </Text>
                                    </Box>
                                </HStack>

                                <Button
                                    as="a"
                                    href={getDocumentUrl(
                                        document.file_path
                                    )}
                                    target="_blank"
                                    variant="ghost"
                                    color="#2453FF"
                                    fontWeight="500"
                                    fontSize="17px"
                                    _hover={{
                                        bg: "transparent",
                                    }}
                                >
                                    <Eye
                                        size={15}
                                        style={{
                                            marginRight:
                                                8,
                                            marginBottom: -3
                                        }}
                                    />
                                    View
                                </Button>
                            </HStack>
                        )
                    )}
                </VStack>
            </Box>
        </Card>
    );
};

const InputField = ({
    label,
    value,
    editable = false,
    onChange,
}) => (
    <Box>
        <Text
            mb={2}
            color="gray.500"
            fontWeight="600"
            fontSize="sm"
        >
            {label}
        </Text>

        <Input
            value={
                value || ""
            }
            readOnly={
                !editable
            }
            onChange={(e) =>
                onChange?.(
                    e.target.value
                )
            }
            bg={
                editable
                    ? "white"
                    : "gray.50"
            }
        />
    </Box>
);

export default PersonalInformation;